/**
 * Created by areynolds2 on 3/27/2017.
 */
import React from 'react';
import gtn from '../GTNexus.Common';

class Question{
    constructor( db_data ){
        this.subtopic = db_data.subtopic;
        this.date = new Date(db_data.entryDate).getHumanReadableDate();
        this.question = {
            tags : db_data.tags,
            text : db_data.question,
            js : db_data.javascriptCode,
            html : db_data.htmlCode,
            json : db_data.jsonCode
        };
        this.answer = {
            text : db_data.answer,
            js : db_data.answerJavascript,
            html : db_data.answerHtml,
            json : db_data.answerJson
        }
    }
}

export default class AppxpressForum extends React.Component {
    constructor(props){
        super(props);
        console.log( props.topic );
        this.searchByKeyword = this.searchByKeyword.bind(this);
        this.parseResponse = this.parseResponse.bind(this);
        this.loadQuestions = this.loadQuestions.bind(this);
        this.loadMoreQuestions = this.loadMoreQuestions.bind(this);
        this.resetBtnClick = this.resetBtnClick.bind(this);
        this.state = { rows : [] , hasMore : false }
    }

    componentDidMount(){
        let hash = location.hash && location.hash.substring(3);
        if( hash  ){
            let keyword = gtn.ui.hyphenDecode( hash );
            $(this.searchInput).val(keyword);
            this.searchByKeyword();
            let top = $(this.myTable).parents('section').position().top - 60 ;
            setTimeout( window.scrollTo.bind(window, 0 , top ) , 400 ) ;
        }else{
            this.loadQuestions(null , 0 );
        }
    }

    showLoading(){
        $(this.myTable).append('<tr class="soho-spinner"><td colspan="3"></td></tr>');
        $(this.myTable).find('.soho-spinner > td').busyindicator({ displayDelay : 0 , text : 'Loading Questions...'}).trigger('start.busyindicator');
    }

    loadQuestions( keywords , offset , callbackFn ){
        this.showLoading();
        $.get('/user/mongo/GetQuestions' , {
            topic : this.props.topic ,
            keywords : keywords,
            offset : offset ,
            limit : 5
        })
            .done( (data) => {
                this.parseResponse(data);
                if(callbackFn) callbackFn();
            })
            .fail( () => {
                $(this.myTable).append('<tr class="m-page-summary-errors"><td colspan="3">Error Connecting to Database - please alert an Evangelist at Infor Nexus for a quick fix! Sorry about the inconvenience</td></tr>')
            })
            .always( () => {
                $(this.myTable).find('.soho-spinner').remove();
            });
    }

    parseResponse(res){
        let temp = this.state.rows;
        for( let result_row of res._result ){
            temp.push( new Question(result_row) );
        }
        this.setState({
            rows : temp ,
            hasMore : res.count > temp.length
        });
        if( this.state.rows.length == 0 ){
            $(this.myTable).append('<tr><td colspan="3">No results found</td></tr>');
        }
        //HIGHLIGHTS CODE SAMPLES
        Prism.highlightAll();
    }

    loadMoreQuestions(e){
        let offset = this.state.rows.length;
        let btnPos = $(e.target).position().top;
        this.loadQuestions( $(this.searchInput).val() , offset , () => {
            ///window.scroll(0 , scrollPos );
            $('body').animate({
                scrollTop: btnPos
            }, 100);
        });
    }

    searchByKeyword(e){
        this.setState({ rows : [] , hasMore : false });
        this.loadQuestions( $(this.searchInput).val() , 0 );
    }

    resetBtnClick(e){
        this.setState({rows : [] , hasMore : false });
        this.loadQuestions(null , 0 )
    }

    render(){
        return (
            <div>
                <div id="forumTableDiv">
                    <label htmlFor="keywordQuery">Enter keywords to search previously asked questions</label>
                    <div className="row">
                        <div className="eight columns forum-input-container">
                            <input type="text" className="full-input" ref={ (input) => { this.searchInput = input; } }/>
                        </div>
                        <div className="two columns">
                            <button className="btn-primary" onClick={ this.searchByKeyword }>Search</button>
                        </div>
                        <div className="two columns">
                            <button className="btn-secondary forum-reset-btn" onClick={ this.resetBtnClick }>Reset</button>
                        </div>
                    </div>
                    <hr/>
                    <table ref={ (table) => { this.myTable = table; } }>
                        <thead>
                        <tr>
                            <th>Question</th>
                            <th className="forum-date-col">Date</th>
                        </tr>
                        </thead>
                        <tbody>
                            { this.state.rows.map( (result, i) =>
                                <ForumRow result={result} key={ result.question.text + i } />
                            )}
                            { this.state.hasMore &&
                                <tr>
                                    <td colSpan="3">
                                        <div style={{ 'text-align' : 'center' }} >
                                            <button className="load-more-question-btn" onClick={ this.loadMoreQuestions }>Load More Questions</button>
                                        </div>
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
};

AppxpressForum.propType = {
    topic : React.PropTypes.string.isRequired
};

class ForumRow extends React.Component {
    constructor(props) { super(props); }
    render(){
        return ( <tr>
            <td>
                <span className="subject-line"> <b>Subject: </b> { this.props.result.subtopic } </span>
                <ul className="k-reset k-multiselect">
                    { this.props.result.question.tags &&
                      this.props.result.question.tags.map( (tag,k) =>
                        <li key={tag + k} className="k-button forum-tag"> { tag } </li>
                    )}
                </ul>
                <b>Question: </b> { this.props.result.question.text }
                { this.props.result.question.js &&
                <pre><code className="language-javascript"> { this.props.result.question.js } </code></pre>
                }
                { this.props.result.question.html &&
                <pre><code className="language-markup"> { this.props.result.question.html } </code></pre>
                }
                { this.props.result.question.json &&
                <pre><code className="language-json"> { this.props.result.question.json } </code></pre>
                }
                <hr/>
                <b>Answer : </b> { this.props.result.answer.text }
                { this.props.result.answer.js &&
                <pre><code className="language-javascript"> { this.props.result.answer.js } </code></pre>
                }
                { this.props.result.answer.html &&
                <pre><code className="language-markup"> { this.props.result.answer.html } </code></pre>
                }
                { this.props.result.answer.json &&
                <pre><code className="language-json"> { this.props.result.answer.json } </code></pre>
                }
            </td>
            <td> { this.props.result.date } </td>
        </tr> );
    }
}


// WEBPACK FOOTER //
// ./public/javascripts/react/forum.js